// Skeleton placeholder for the top-posts board during the initial fetch.

import { cn } from "@shared/lib";

import { TOP_POSTS_STRINGS } from "../lib/strings";

export interface TopPostsBoardSkeletonProps {
  loadingLabel?: string;
  className?: string;
}

export function TopPostsBoardSkeleton({
  loadingLabel = TOP_POSTS_STRINGS.title,
  className,
}: TopPostsBoardSkeletonProps) {
  return (
    <section
      aria-busy="true"
      aria-label={loadingLabel}
      className={cn("flex animate-pulse flex-col gap-2", className)}
    >
      <div className="h-4 w-24 rounded bg-muted" />
      <div className="h-3 w-48 rounded bg-muted" />
      <ul className="flex flex-col gap-2 pt-2">
        {Array.from({ length: 5 }, (_, idx) => (
          <li
            key={idx}
            className="flex items-center justify-between gap-3 rounded-lg border bg-background px-4 py-3"
          >
            <div className="flex min-w-0 items-center gap-3">
              <div className="h-7 w-7 flex-none rounded-full bg-muted" />
              <div className="flex min-w-0 flex-col gap-1">
                <div className="h-3 w-24 rounded bg-muted" />
                <div className="h-3 w-16 rounded bg-muted" />
              </div>
            </div>
            <div className="flex flex-none flex-col items-end gap-1">
              <div className="h-3 w-12 rounded bg-muted" />
              <div className="h-3 w-12 rounded bg-muted" />
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
